import { UseLoggedContext } from '@mercadoni/sinister/dist/cjs/authentication'
import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client'
import { isLocationEnabled } from '@mercadoni/sinister/dist/cjs/shared/utils'
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import { useCallback } from 'react'

interface UseGuessActionProps {
  router: AppRouterInstance
  forceToLogin: boolean
}

const useGuessAction = ({ router, forceToLogin }: UseGuessActionProps) => {
  const { disableGuestCart } = UseClientModelContext()
  const { isLogged } = UseLoggedContext()
  const redirectTo = useCallback(() => {
    const redirectToNewCustomer = disableGuestCart && !isLogged
    const addressPath = isLocationEnabled() ? '/location2' : '/orderType'
    const url = redirectToNewCustomer || forceToLogin ? '/login' : addressPath
    router.push(url, { scroll: false })
  }, [disableGuestCart, isLogged, forceToLogin, router])
  return useCallback(() => {
    redirectTo()
  }, [redirectTo])
}
export default useGuessAction
